import { render } from "./SettingsTasks.vue?vue&type=template&id=18195dea"
import script from "./SettingsTasks.vue?vue&type=script&lang=js"
export * from "./SettingsTasks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__